import HttpRequest from '@/config/axios.config'
import { UPLOAD_DOCUMENTS_ENDPOINT } from '@/constant/common'
import { isEmptyValue } from '@/utils/common'
import FormDataLib from 'form-data'

interface UploadFileOptions {
  endpoint?: string
  fieldName?: string
}

export interface IFileItem {
  id?: string
  name?: string
  url?: string
  url_path?: string
  size?: number
  uid?: string
  status?: string
  originFileObj?: File
  [key: string]: any
}

export function useFileUpload(options?: UploadFileOptions) {
  const endpoint = options?.endpoint || UPLOAD_DOCUMENTS_ENDPOINT
  const fieldName = options?.fieldName || 'files'

  const uploadFiles = async (
    fileList: IFileItem[] = []
  ): Promise<IFileItem[]> => {
    if (isEmptyValue(fileList)) {
      return []
    }

    const formData: any = new FormDataLib()
    const existingFiles: IFileItem[] = []
    let hasNewFiles = false

    for (const file of fileList) {
      if (file.originFileObj) {
        formData.append(fieldName, file.originFileObj)
        hasNewFiles = true
      } else {
        existingFiles.push(file)
      }
    }

    let newUploadedFiles: IFileItem[] = []
    if (hasNewFiles && formData.has(fieldName)) {
      const response = await HttpRequest.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      newUploadedFiles = response?.data?.data || []
    }

    return [
      ...existingFiles,
      ...(Array.isArray(newUploadedFiles) ? newUploadedFiles : []),
    ]
  }

  return { uploadFiles }
}
